import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import axios from 'axios'
import {setConfig, Log} from 'log-tool' // log-tool 核心
import ConfigLog from '@/config/log' // log-tool 配置项
import ElementUI from 'element-ui'; //Element UI 核心
import echarts from 'echarts' //echarts 图表
// import 'element-ui/lib/theme-chalk/index.css';
// import 'echarts/lib'
import '@/assets/element/index.css'; //Element UI style
import '@/assets/iconfont/iconfont.css' // iconfont
import McOpDevFeLib from '@/assets/mc-opdev-fe-lib/index.js' // MC通用组件

import '@/style/index.less' // 全局style 库
import api from '@/apis/index.js' // 全局api库
import mock from '@/mock/index.js' // 全局mock数据

import { formatDate } from '@/assets/mc-opdev-fe-lib/libs/common.js' // libs 工具类库

setConfig(ConfigLog)

window.axios = axios;
window.Log = Log;
window.echarts = echarts;
window.formatDate = formatDate;

Vue.use(ElementUI);
Vue.use(McOpDevFeLib);
Vue.use(api);
Vue.use(mock)
// Vue.use(echarts)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
